module.exports = require('./helpers/bundle-url').getBundleURL('3NeWw') + "logo.c51670a8.svg";